module.exports = __webpack_public_path__ + "r-v3/img/pen_gray.905e0d9e.svg";